export const LOCAL_STORAGE_MY_NEWS_LAST_ADDED_DATE_KEY =
  'my_news_last_added_date';
export const LOCAL_STORAGE_TODAY_GIFT_LAST_ADDED_DATE_KEY =
  'today_gift_last_added_date';
export const LOCAL_STORAGE_WAITFREE_PLUS_LAST_ADDED_DATE_KEY =
  'waitfree_plus_last_added_date';
export const LOCAL_STORAGE_NOTICE_LAST_ADDED_DATE_KEY =
  'notice_last_added_date';
export const CONFIG_STATE_NAME = 'config';
export const SESSION_STORAGE_IPX_MEDIA_MUTED_KEY = 'ipx_media_muted';
export const LOCAL_STORAGE_IPX_MEDIA_NETWORK_USING_AGREED_KEY =
  'ipx_media_using_network_agreed';
